export default __webpack_public_path__ + "static/media/img456.72ec059a.jpg";